import {
  HttpClient,
  HttpEvent,
  HttpEventType,
  HttpResponse,
} from "@angular/common/http";
import { ChangeDetectorRef, Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Console } from "console";

import { ToastrService } from "ngx-toastr";
import { BundleService } from "src/app/Services/bundleservice.service";
import { GetContentService } from "src/app/Services/getcontent.service";
import { FlowQueryModel } from "src/app/models/flowquerymodel";
import { environment } from "src/environments/environment";
import { SelectionRephraseAIComponent } from "../selection-rephraseAi-dialog/selection-rephraseAi-dialog.component";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { FlowQueryService } from "src/app/shared/flowquery.helper";
import { MediaUploadService } from "src/app/Services/media-upload.service";
import { catchError, debounceTime, map, shareReplay } from "rxjs/operators";
import { Observable, Subject, of } from "rxjs";
import {
  LoadingModalComponent,
  LoadingModalData,
} from "../loading-modal/loading-modal.component";
import { EnhancedRestrictedAccessComponent } from "../enhanced-restricted-access/enhanced-restricted-access.component";
import { LeaveConfirmationDialogComponent } from "src/app/shared/components/leave-confirmation-dialog/leave-confirmation-dialog.component";
import { FlowNavigationService } from "src/app/Services/flow-navigation.service";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { OrgContextService } from "src/app/Services/org-context.service";

type BundleJourneyTabId =
  | "cover"
  | "documents"
  | "pricing"
  | "flows"
  | "summary";

type BundlePublishAccess = "Public" | "Private" | "Restricted";

interface BundleJourneyTabConfig {
  id: BundleJourneyTabId;
  label: string;
}

@Component({
  selector: "app-edit-bundle",
  templateUrl: "./edit-bundle.component.html",
  styleUrls: ["./edit-bundle.component.scss"],
})
export class EditBundleComponent implements OnInit {
  description: string;
  title: string;
  operationInProgress: boolean;
  bundleImageUrl: string;
  fileData: File = null;
  showVideo: boolean;
  fileName: string;
  noResultReturned: boolean;
  addbundleselectedflows: [];
  userData: any;
  selectedFlowIds: any[];
  showFlows: boolean;
  bFlows: boolean;
  coverImageUri: any;
  bundleId: any;
  uniqueId: any;
  CategoryName: any;
  showDeleteContentMenu: boolean;
  private _flows: any;
  allBundleFlows: any[];
  flowTitle: any;
  flowUniqueCode: any;
  flowImage: any;
  flowUserProfilePic: any;
  flowuserName: any;
  flowUserName: any;
  bundleData: any;
  showMenu: boolean;
  imageSource: string;
  videoPlayCounter: any;
  viewUnloaded: any;
  bundleFlows: any;
  price: any;
  isPaid: boolean;
  sffilelink: any;
  isAddSupportingDocument: boolean;
  linkName: any;
  hyperLink: any;
  supportingDocumentHyperLinks: any[];
  supportingDocumentDocuments: any[];
  documentName: any;
  noApprovedFlows: any;
  tabIndex: number;
  FlowCount: number;
  sffilename: string;
  totalSupportingDocuments: number;
  showMessage: boolean;
  selectedFlow: boolean;
  progress: number = 0;
  isLoading: boolean = false;
  showImage: boolean = false;
  showImagetoggle: any;
  coverPageURI: string;
  coverPosterPageURI: string;
  filename: any;
  uploadProgress: number;
  posterUrl: string;
  selectedFile: File;
  showPercentage: boolean;
  enableTransferAfterPublish: boolean = false;
  showDescriptionExpanded: boolean = false;

  // Loading modal
  loadingModalRef: MatDialogRef<LoadingModalComponent> = null;

  // Thumbnail selection state
  coverThumbnails: string[] = [];
  isCoverThumbnailLoading: boolean = false;
  coverThumbnailError: string = "";
  customCoverThumbnailUploading: boolean = false;
  coverThumbnailUploadProgress: number = 0;
  generatedCoverThumbnailUrl: string = "";
  customCoverThumbnailUrl: string = "";
  customCoverThumbnailFile: File = null;
  thumbnailSelectionMode: "auto" | "upload" | "compare" = "auto";
  isThumbnailDialogOpen = false;
  thumbnailDialogMode: "auto" | "upload" | "compare" = "auto";
  selectedAutoThumbnailUrl: string = "";
  selectedAutoThumbnailFile: File = null;

  // Video player state for thumbnail selection
  videoDuration: number = 0;
  currentVideoTime: number = 0;
  @ViewChild("coverVideoPlayer") coverVideoPlayer: ElementRef<HTMLVideoElement>;
  @ViewChild("thumbnailUploadInput")
  thumbnailUploadInput: ElementRef<HTMLInputElement>;

  // Flow selection popup properties
  showAddFlowsPopup: boolean = false;
  tempFlows: any[] = [];
  /** Published guides by other organization members visible to this user (org-scoped packs only). */
  private orgTeamGuides$: Observable<any[]> | null = null;
  searchInput: string = "";
  flowSearchNoResultReturned: boolean = false;
  /** Selected publish access for this bundle. */
  bundleAccessType: BundlePublishAccess = "Public";
  showMatchingAccessOnly = false;
  restrictedAccessType = "";
  isSearchHidden = false;
  savedAccessFlows: any[] = [];
  savedAccessAdvanced: any = {};
  flowSearchInformation: string =
    "All your flows are shown. Bundle publish access is set separately above.";
  private flowSearchTerms = new Subject<string>();
  /** Derived flow ordering for persistence and view rendering. */
  private buildFlowSequenceModel(): { FlowId: any; Sequence: number }[] {
    const list: any[] = Array.isArray(this.bundleFlows) ? this.bundleFlows : [];
    return list
      .map((item, idx) => ({
        FlowId: item?.flow?.rowKey,
        Sequence: idx + 1,
      }))
      .filter((x) => x.FlowId !== null && x.FlowId !== undefined && `${x.FlowId}`.trim() !== "");
  }

  /** When true, flow order is persisted for viewers (FlowSequence + flowsSequenced). */
  bundleFlowsSequenced: boolean = false;

  // Journey tabs structure
  bundleJourneyTabs: BundleJourneyTabConfig[] = [
    { id: "cover", label: "Bundle Title" },
    { id: "documents", label: "Supporting Documents" },
    { id: "flows", label: "Flows" },
    { id: "pricing", label: "Pricing" },
    { id: "summary", label: "Summary" },
  ];
  activeBundleJourneyTab: BundleJourneyTabId = "cover";
  private visitedBundleTabs: Set<BundleJourneyTabId> = new Set<BundleJourneyTabId>();

  // Rephrase properties
  originalTitleText!: string;
  repharaseButtonTitleText: string = "Rephrase text with AI";
  isTitleRephrased: boolean = false;
  isTitleRephraseInProgress: boolean = false;
  originalContentTitleText!: string;
  repharaseButtonText: string = "Rephrase text with AI";
  isRephrased: boolean = false;
  isRephraseInProgress: boolean = false;

  constructor(
    private router: Router,
    private flowNavigationService: FlowNavigationService,
    private http: HttpClient,
    private bundleService: BundleService,
    private getContentService: GetContentService,
    private activateRouter: ActivatedRoute,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private flowServiceService: FlowServiceService,
    private flowQueryService: FlowQueryService,
    private mediaUploadService: MediaUploadService,
    private orgContext: OrgContextService
  ) {
    this.bundleFlows = [];
    this.title = "";
    this.description = "";
    this.operationInProgress = false;
    this.selectedFlowIds = [];
    this.supportingDocumentHyperLinks = [];
    this.supportingDocumentDocuments = [];
  }

  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    let bundleData = JSON.parse(localStorage.getItem("createbundledetails"));
    
    // Setup search debounce for flow search
    this.flowSearchTerms.pipe(debounceTime(2000)).subscribe(() => {
      localStorage.removeItem("addbundlePageIndex");
      localStorage.setItem("addbundlePageIndex", "0");
      this.performFlowSearch(0);
    });

    this.activateRouter.paramMap.subscribe((params) => {
      var bundleId = params.get("id");
      this.bundleId = bundleId;
      if (bundleId != null && bundleId != "") this.getBundleDetails(bundleId);
    });
    console.log(bundleData);
    
    // Mark the initially active tab as visited since user is viewing it
    this.visitedBundleTabs.add(this.activeBundleJourneyTab);
  }
  // originalTitleText!: string;
  // repharaseButtonTitleText: string = "Rephrase text with AI";
  // isTitleRephrased: boolean = false;
  // isTitleRephraseInProgress: boolean = false;

  // GoToOriginalTitleText() {
  //   this.bundleData.title = this.originalTitleText;
  // }

  // async rephraseTitleText(input: string) {

  //   if (input == undefined || input == "") {
  //     this.toastr.warning(
  //       "The Text To Rephrase is required."
  //     );
  //     return;
  //   }

  //   if (!this.isTitleRephrased) {
  //     this.originalTitleText = input;
  //   }

  //   this.isTitleRephrased = true;
  //   this.isTitleRephraseInProgress = true;
  //   console.log(input);
  //   var aiModel = {
  //     textToRephrase: input
  //   };
  //   (await this.getContentService
  //     .getContentFromAI(aiModel))
  //   .subscribe((aiResponse) => {
  //     if(aiResponse){
  //       console.log(aiResponse);
  //       console.log(aiResponse[0].completions);
  //       this.bundleData.title = aiResponse[0].completions;
  //       this.isTitleRephraseInProgress = false;
  //     }
  //   });
  //   this.isTitleRephraseInProgress = false;
  // }

  // originalContentTitleText!: string;
  // repharaseButtonText: string = "Rephrase text with AI";
  // isRephrased: boolean = false;
  // isRephraseInProgress: boolean = false;

  // GoToOriginalText() {
  //   this.bundleData.description = this.originalContentTitleText;
  // }

  // async rephraseDescriptionText(input: string) {

  //   if (input == undefined || input == "") {
  //     this.toastr.warning(
  //       "The Text To Rephrase is required."
  //     );
  //     return;
  //   }

  //   if (!this.isRephrased) {
  //     this.originalContentTitleText = input;
  //   }

  //   this.isRephrased = true;
  //   this.isRephraseInProgress = true;
  //   console.log(input);
  //   var aiModel = {
  //     textToRephrase: input
  //   };
  //   (await this.getContentService
  //     .getContentFromAI(aiModel))
  //   .subscribe((aiResponse) => {
  //     if(aiResponse){
  //       console.log(aiResponse);
  //       console.log(aiResponse[0].completions);
  //       this.bundleData.description = aiResponse[0].completions;
  //       this.isRephraseInProgress = false;
  //     }
  //   });
  //   this.isRephraseInProgress = false;

  // }
  drop(event: CdkDragDrop<any[]>) {
    if (!this.bundleFlows || this.bundleFlows.length === 0) {
      return;
    }
    moveItemInArray(this.bundleFlows, event.previousIndex, event.currentIndex);
    localStorage.setItem("addbundleselectedflows", JSON.stringify(this.bundleFlows));
  }

  persistFlowsSequencedToLocalDetails(): void {
    try {
      const raw = localStorage.getItem("createbundledetails");
      const existing = raw ? JSON.parse(raw) : {};
      existing.flowsSequenced = this.bundleFlowsSequenced;
      localStorage.setItem("createbundledetails", JSON.stringify(existing));
    } catch {
      /* ignore */
    }
    if (this.bundleData) {
      this.bundleData.flowsSequenced = this.bundleFlowsSequenced;
    }
  }

  getBundleDetails(bundleId) {
    this.bundleFlows = [];
    this.operationInProgress = true;
    var email = "";
    if (this.userData != null && this.userData != undefined) {
      email = this.userData.emailAddress;
    }

    var flowQueryModel = new FlowQueryModel({
      BundleId: bundleId,
      userEmail: email,
    });

    this.bundleService.getBundleById(flowQueryModel).subscribe((data) => {
      this.operationInProgress = false;
      if (data.bundleModel != null) {
        this.bundleData = data.bundleModel;
        this.addbundleselectedflows = JSON.parse(
          localStorage.getItem("addbundleselectedflows")
        );

        let flowsSequencedFromLocalDraft = false;
        let localDraftBundleModel: any = null;
        if (localStorage.getItem("createbundledetails") != null) {
          var bundleModel = JSON.parse(
            localStorage.getItem("createbundledetails")
          );
          localDraftBundleModel = bundleModel;

          if (bundleModel != null && bundleModel != undefined) {
            this.bundleData.title = bundleModel.title;
            this.bundleData.description = bundleModel.description;
            this.bundleData.url = bundleModel.url;
            this.bundleData.id = bundleModel.rowKey;
            this.bundleData.isPaid = bundleModel.isPaid;
            this.bundleData.price = bundleModel.price;
            if (
              bundleModel.flowsSequenced === true ||
              bundleModel.flowsSequenced === false
            ) {
              this.bundleFlowsSequenced = bundleModel.flowsSequenced;
              flowsSequencedFromLocalDraft = true;
            }
            this.bundleData.flowSupportingDocumentsHyperLinkModels =
              bundleModel.flowSupportingDocumentsHyperLinkModels;
            this.bundleData.flowSupportingDocumentsDocumentModels =
              bundleModel.flowSupportingDocumentsDocumentModels;
            this.bundleData.flowSupportingDocumentsHyperLinkModels.length =
              bundleModel.flowSupportingDocumentsHyperLinkModels.length;
            this.bundleData.flowSupportingDocumentsDocumentModels.length =
              bundleModel.flowSupportingDocumentsDocumentModels.length;
          }
        }

        const draftMatchesCurrentBundle = this.localDraftMatchesBundle(
          localDraftBundleModel,
          bundleId,
          this.bundleData
        );

        const storedFlows = this.addbundleselectedflows;
        if (
          draftMatchesCurrentBundle &&
          Array.isArray(storedFlows) &&
          storedFlows.length > 0
        ) {
          this.bundleFlows = storedFlows;
        } else if (Array.isArray(this.bundleData.flows)) {
          this.bundleFlows = [];
          this.bundleData.flows.forEach((element) => {
            this.bundleFlows.push({ flow: element, isSelected: true });
          });
          localStorage.setItem(
            "addbundleselectedflows",
            JSON.stringify(this.bundleFlows)
          );
        }

        if (!flowsSequencedFromLocalDraft) {
          const seqFlag =
            this.bundleData.flowsSequenced ?? this.bundleData.FlowsSequenced;
          const seqArr =
            this.bundleData.flowSequence ||
            this.bundleData.FlowSequence ||
            [];
          if (seqFlag === true) {
            this.bundleFlowsSequenced = true;
          } else if (seqFlag === false) {
            this.bundleFlowsSequenced = false;
          } else {
            this.bundleFlowsSequenced =
              Array.isArray(seqArr) && seqArr.length > 0;
          }
        }
        this.showVideoFromFile(this.bundleData.url);
        this.isImageOrVideo(this.bundleData.url);

        // Initialize supporting documents arrays from bundleData
        if (this.bundleData.flowSupportingDocumentsDocumentModels) {
          this.supportingDocumentDocuments = [...this.bundleData.flowSupportingDocumentsDocumentModels];
        }
        if (this.bundleData.flowSupportingDocumentsHyperLinkModels) {
          this.supportingDocumentHyperLinks = [...this.bundleData.flowSupportingDocumentsHyperLinkModels];
        }

        // Calculate total supporting documents
        this.totalSupportingDocuments =
          (this.bundleData.flowSupportingDocumentsDocumentModels?.length || 0) +
          (this.bundleData.flowSupportingDocumentsHyperLinkModels?.length || 0);

        if (this.bundleFlows.length >= 2) {
          this.bFlows = true;
        } else {
          this.bFlows = false;
        }

        this.loadBundleAccessTypeAfterDetails(this.bundleData, bundleId);

        if (
          this.userData != null &&
          this.userData.emailAddress != this.bundleData.customerEmail
        ) {
          this.showMenu = true;
        } else {
          this.showMenu = false;
        }

        // Initialize journey tabs
        this.activeBundleJourneyTab = "cover";
        
        // Check if bundleData has required properties for journey completion
        if (this.bundleData.url) {
          this.isImageOrVideo(this.bundleData.url);
        }
      } else {
        this.toastr.success(
          "The bundle you are trying to open is no longer available. Explore how-to DIY bundles here"
        );
        this.router.navigate(["/"]);
      }
    });
  }

  checkValue() {
    console.log(this.bundleData.isPaid);
    if (!this.bundleData.isPaid) {
      this.bundleData.price = null;
    }
  }

  showVideoFromFile(filePath: string) {
    if (
      filePath.includes("MP4") ||
      filePath.includes("mp4") ||
      filePath.includes("MOV") ||
      filePath.includes("mov") ||
      filePath.includes("WMV") ||
      filePath.includes("wmv") ||
      filePath.includes("FLV") ||
      filePath.includes("flv") ||
      filePath.includes("AVCHD") ||
      filePath.includes("avchd") ||
      filePath.includes("WEBM") ||
      filePath.includes("webm") ||
      filePath.includes("MKV") ||
      filePath.includes("mkv") ||
      filePath.includes("VOB") ||
      filePath.includes("vob") ||
      filePath.includes("OGV") ||
      filePath.includes("ogv") ||
      filePath.includes("GIFY") ||
      filePath.includes("gifv") ||
      filePath.includes("M4P") ||
      filePath.includes("m4p") ||
      filePath.includes("M4V") ||
      filePath.includes("m4v") ||
      filePath.includes("3GP") ||
      filePath.includes("3gp") ||
      filePath.includes("3G2") ||
      filePath.includes("3g2") ||
      filePath.includes("AMV") ||
      filePath.includes("amv") ||
      filePath.includes("NSV") ||
      filePath.includes("nsv") ||
      filePath.includes("OGG") ||
      filePath.includes("ogg") ||
      filePath.includes("FLV") ||
      filePath.includes("flv") ||
      filePath.includes("F4V") ||
      filePath.includes("f4v") ||
      filePath.includes("F4P") ||
      filePath.includes("f4p") ||
      filePath.includes("F4A") ||
      filePath.includes("f4a") ||
      filePath.includes("F4B") ||
      filePath.includes("f4b")
    ) {
      this.showVideo = true;
      this.imageSource = filePath;
    } else {
      this.showImage = false;
      this.imageSource = filePath;
    }
  }

  vidEnded(event) {
    var playcount = 0;
    var video = this.videoPlayCounter.filter(
      (v) => v.currentSrc == event.target.currentSrc
    );
    if (video != null) {
      playcount = video.length;
    }

    if (playcount < 3) {
      this.videoPlayCounter.push({
        eventobj: event,
        currentSrc: event.target.currentSrc,
        playcount: playcount,
      });
      event.target.play();
    }
  }

  vidfocus(event) {}

  vidplay(event) {
    if (!this.viewUnloaded) {
      var videos = this.videoPlayCounter.filter((v) => v.id == event.target.id);

      if (videos.length > 3) {
        videos.forEach((element) => {
          var obj = this.videoPlayCounter.indexOf(element);

          if (obj > -1) {
            this.videoPlayCounter.splice(obj, 1);
          }
        });
      }
      event.target.play();
    }
  }

  saveFlowToServerAccessLevel(accessType) {
    const normalizedAccess = this.persistableBundleAccessType(
      this.normalizeBundleAccessType(accessType)
    );
    if (this.normalizeBundleAccessType(normalizedAccess) !== this.bundleAccessType) {
      this.toastr.warning(
        `Publish access must match the type selected in the Flows tab (${this.getBundleAccessLabel()}).`
      );
      return;
    }

    console.log(this.bundleData);
    this.selectedFlow = false;
    console.log(this.bundleFlows);
    console.log(this.selectedFlow);
    this.operationInProgress = true;
    // Always rebuild ids from the current ordered list to avoid duplicates across attempts.
    this.selectedFlowIds = (this.bundleFlows || []).map(
      (element: any) => element?.flow?.rowKey
    );
    const flowSequence = this.bundleFlowsSequenced
      ? this.buildFlowSequenceModel()
      : [];

    console.log(this.selectedFlowIds);

    var paidFlow = this.bundleFlows.some((f) => f.flow.price != null);

    console.log(paidFlow);

    var bundlePrice = this.bundleData.price;
    console.log(bundlePrice);

    if (paidFlow && bundlePrice == null) {
      this.selectedFlow = true;
      this.toastr.warning(
        "Please add price to bundle to publish as you have selected paid flows to be part of this bundle."
      );
      return;
    }

    if (!paidFlow && (bundlePrice != null || bundlePrice > 0)) {
      this.selectedFlow = true;
      this.toastr.warning(
        "Please add paid flows to bundle to publish as you have added price to this bundle."
      );
      return;
    }

    var bundleModel = {
      userName: this.userData.userName,
      uniqueId: this.bundleData.uniqueId,
      description: this.bundleData.description,
      customerEmail: this.userData.emailAddress,
      title: this.bundleData.title,
      accessType: normalizedAccess,
      ...this.buildRestrictedBundleFields(),
      url: this.bundleData.url,
      type: "Bundle",
      bundleStatus: "Approved",
      flowIds: this.selectedFlowIds,
      flowsSequenced: this.bundleFlowsSequenced,
      flowSequence: flowSequence,
      rowKey: this.bundleData.rowKey,
      price: this.bundleData.price,
      isPaid: this.bundleData.isPaid,
      flowSupportingDocumentsHyperLinkModels:
        this.bundleData.flowSupportingDocumentsHyperLinkModels,
      flowSupportingDocumentsDocumentModels:
        this.bundleData.flowSupportingDocumentsDocumentModels,
      PartitionKey: this.bundleData.customerEmail,
    };

    this.progress = 0;
    if (this.userData != null) {
      if (this.bundleData.price != null) {
        this.bundleService
          .PostBundle(bundleModel, this.userData.emailAddress)
          .subscribe({
            next: (event: HttpEvent<any>) => {
              switch (event.type) {
                case HttpEventType.Sent:
                  console.log("Request sent to server.");
                  break;

                case HttpEventType.UploadProgress:
                  this.progress = Math.round(
                    (95 * event.loaded) / (event.total || 1)
                  );
                  console.log(`Progress: ${this.progress}%`);
                  break;

                case HttpEventType.Response:
                  console.log("Upload complete:", event.body);
                  localStorage.setItem("draftTabIndex", "1");
                  this.cdr.detectChanges();

                  setTimeout(() => {
                    this.progress = 100;
                    console.log("set is loading");
                    this.noResultReturned = false;
                    this.toastr.success("Bundle successfully published");
                    this.router.navigate(["/user-profile"]);
                    this.resetProgress();
                  }, 5000);

                  break;

                default:
                  console.log("Unhandled event:", event);
              }
            },
            error: (err) => {
              console.error("Error uploading:", err);
              this.resetProgress();
            },
          });
        console.log(
          "Included paid flows also added price",
          this.bundleData.price
        );
      } else {
        if (
          this.bundleData.price == null ||
          this.bundleData.price == undefined
        ) {
          this.bundleService
            .PostBundle(bundleModel, this.userData.emailAddress)
            .subscribe({
              next: (event: HttpEvent<any>) => {
                switch (event.type) {
                  case HttpEventType.Sent:
                    console.log("Request sent to server.");
                    break;

                  case HttpEventType.UploadProgress:
                    this.progress = Math.round(
                      (95 * event.loaded) / (event.total || 1)
                    );
                    console.log(`Progress: ${this.progress}%`);
                    break;

                  case HttpEventType.Response:
                    console.log("Upload complete:", event.body);
                    localStorage.setItem("draftTabIndex", "1");
                    this.cdr.detectChanges();

                    setTimeout(() => {
                      this.progress = 100;
                      console.log("set is loading");
                      this.noResultReturned = false;
                      this.toastr.success("Bundle successfully published");
                      this.router.navigate(["/user-profile"]);
                      this.resetProgress();
                    }, 5000);

                    break;

                  default:
                    console.log("Unhandled event:", event);
                }
              },
              error: (err) => {
                console.error("Error uploading:", err);
                this.resetProgress();
              },
            });
          //console.log("Free bundle publish", this.bundleData.price);
        } else {
          this.noResultReturned = false;
          this.showMessage = true;
          this.toastr.warning(
            "Please add price to bundle to publish as you have selected paid flows to be part of this bundle."
          );
        }
      }
    }
  }

  resetProgress() {
    setTimeout(() => {
      this.progress = 0;
      this.isLoading = false;
    }, 500); // Small delay before hiding progress
  }

  uploadSupportingDocuments(event) {
    if (event.target.files) {
      this.noResultReturned = true;
      this.openLoadingModal("Uploading document...", true);
      //
      this.fileData = <File>event.target.files[0];
      const formData = new FormData();
      formData.append("fileData", this.fileData);

      // this.isStepCoverPageURISet = true;
      this.isAddSupportingDocument = true;
      if (
        this.fileData.name.includes("pdf") ||
        this.fileData.name.includes("PDF")
      ) {
        this.http
          .post(
            environment.apiBaseUrl + environment.uploadDocumentsUrl,
            formData,
            {
              reportProgress: true,
              observe: "events",
            }
          )
          .subscribe({
            next: (event: HttpEvent<any>) => {
              switch (event.type) {
                case HttpEventType.UploadProgress:
                  if (event.total) {
                    const progress = Math.round(
                      (event.loaded / event.total) * 100
                    );
                    this.updateLoadingModal("Uploading document...", progress);
                  }
                  break;
                case HttpEventType.Response:
                  var mediaUploadStatus = event.body as any;
                  this.showImage = true;
                  this.showVideo = false;
                  this.noResultReturned = false;
                  this.closeLoadingModal();
                  //
                  if (mediaUploadStatus != null) {
                    this.sffilename = mediaUploadStatus.fileName;
                    this.sffilelink =
                      environment.documentsStorageBaseUrl +
                      mediaUploadStatus.fileName;
                    this.toastr.success("Document uploaded successfully");
                  } else {
                    this.toastr.error(
                      mediaUploadStatus?.message || "Upload failed"
                    );
                  }
                  break;
              }
            },
            error: (error) => {
              this.noResultReturned = false;
              this.closeLoadingModal();
              this.toastr.error("Failed to upload document. Please try again.");
              console.error("Error uploading document:", error);
            },
          });
      } else {
        this.closeLoadingModal();
        this.toastr.warning("Please upload a PDF file");
      }
    }
  }

  restrictedAccessPage(accessType) {
    var bundleModel = {
      uniqueId: this.bundleData.uniqueId,
      Description: this.bundleData.Description,
      CustomerEmail: this.userData.EmailAddress,
      Title: this.bundleData.Title,
      AccessType: accessType,
      Url: this.bundleData.Url,
      Type: "Bundle",
      BundleStatus: "Approved",
      FlowIds: this.selectedFlowIds,
      Id: this.bundleData.Id,
    };
    localStorage.setItem("flowModel", JSON.stringify(bundleModel));
    this.router.navigate(["/restricted-guide-pack"]);
  }

  flowClicked(flow) {}

  viewUserProfile(flow) {}

  addflowstoBundle() {
    this.showAddFlowsPopup = true;
    this.tempFlows = [];
    this.searchInput = "";
    this.getApprovedFlows();
  }

  onMatchingAccessToggleChange(): void {
    if (this.showAddFlowsPopup) {
      this.getApprovedFlows();
    }
    this.updateFlowSearchInformation();
  }

  setBundleAccessType(accessType: BundlePublishAccess): void {
    if (this.bundleAccessType === accessType) {
      return;
    }
    this.bundleAccessType = accessType;
    if (accessType === "Public") {
      this.restrictedAccessType = "";
      this.isSearchHidden = false;
      this.savedAccessFlows = [];
      this.savedAccessAdvanced = {};
    } else if (accessType === "Private") {
      this.restrictedAccessType = "";
      this.isSearchHidden = true;
      this.savedAccessFlows = [];
      this.savedAccessAdvanced = {};
    }
    this.updateFlowSearchInformation();
    this.persistBundleAccessTypeToLocalDetails();
    if (this.showMatchingAccessOnly && this.showAddFlowsPopup) {
      this.getApprovedFlows();
    }
  }

  openBundleRestrictedAccess(): void {
    if (!this.userData?.emailAddress) {
      this.toastr.error("User data is missing. Please sign in again.");
      return;
    }

    const bundleModel: any = {
      uniqueId: this.bundleData?.uniqueId,
      description: this.bundleData?.description,
      customerEmail: this.userData.emailAddress,
      title: this.bundleData?.title,
      AccessType: "Restricted",
      accessType: "Restricted",
      RestrictedAccessType: this.restrictedAccessType || "",
      restrictedAccessType: this.restrictedAccessType || "",
      IsSearchHidden: this.isSearchHidden,
      isSearchHidden: this.isSearchHidden,
      restrictedAccessFlows: this.savedAccessFlows || [],
      RestrictedAccessFlows: this.savedAccessFlows || [],
      ...(this.savedAccessAdvanced || {}),
      url: this.bundleData?.url,
      Type: "Bundle",
      type: "Bundle",
      RowKey: this.bundleData?.rowKey,
      rowKey: this.bundleData?.rowKey,
      PartitionKey: this.bundleData?.customerEmail,
    };

    localStorage.setItem("flowModel", JSON.stringify(bundleModel));
    const dialogRef = this.dialog.open(EnhancedRestrictedAccessComponent, {
      panelClass: "dialoguebox",
      data: {
        mode: this.bundleData?.rowKey ? "update" : "configure",
        contentType: "bundle",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const access = String(
          result.accessType || result.AccessType || "Restricted"
        ).toLowerCase();
        if (access === "private") {
          this.setBundleAccessType("Private");
          return;
        }
        if (access === "public") {
          this.setBundleAccessType("Public");
          return;
        }
        this.applyBundleRestrictedResult(result);
      }
    });
  }

  private applyBundleRestrictedResult(result: any): void {
    this.bundleAccessType = "Restricted";
    this.restrictedAccessType =
      result.restrictedAccessType || result.RestrictedAccessType || "";
    this.isSearchHidden =
      result.isSearchHidden ?? result.IsSearchHidden ?? false;
    const flows =
      result.restrictedAccessFlows || result.RestrictedAccessFlows;
    if (flows) {
      this.savedAccessFlows = flows;
    }
    this.savedAccessAdvanced = {
      EnforceNetwork: result.enforceNetwork ?? result.EnforceNetwork ?? false,
      EnforceGeo: result.enforceGeo ?? result.EnforceGeo ?? false,
      EnforceDevice: result.enforceDevice ?? result.EnforceDevice ?? false,
      EnforceCompanyEmail:
        result.enforceCompanyEmail ?? result.EnforceCompanyEmail ?? false,
      AllowedCidrs: result.allowedCidrs ?? result.AllowedCidrs ?? "",
      GeoFenceJson: result.geoFenceJson ?? result.GeoFenceJson ?? null,
      AllowedDeviceIds:
        result.allowedDeviceIds ?? result.AllowedDeviceIds ?? "",
      AllowedEmailDomains:
        result.allowedEmailDomains ?? result.AllowedEmailDomains ?? "",
    };
    this.updateFlowSearchInformation();
    this.persistBundleAccessTypeToLocalDetails();
    if (this.showMatchingAccessOnly && this.showAddFlowsPopup) {
      this.getApprovedFlows();
    }
  }

  updateFlowSearchInformation(): void {
    if (this.showMatchingAccessOnly) {
      if (this.bundleAccessType === "Private") {
        this.flowSearchInformation =
          "Only your private flows are shown. Turn off the filter below to see all flows.";
      } else if (this.bundleAccessType === "Restricted") {
        this.flowSearchInformation =
          "Only flows matching your bundle restricted settings are shown. Turn off the filter below to see all flows.";
      } else {
        this.flowSearchInformation =
          "Only your public flows are shown. Turn off the filter below to see all flows.";
      }
      return;
    }
    this.flowSearchInformation =
      "All your flows are shown. Bundle publish access is set separately above.";
  }

  getBundleAccessLabel(): string {
    if (this.bundleAccessType === "Private") {
      return "Private to you";
    }
    if (this.bundleAccessType === "Restricted") {
      const restrictedType = String(this.restrictedAccessType || "");
      const users = this.savedAccessFlows || [];
      const adv = this.savedAccessAdvanced || {};
      const hasAdvanced = !!(
        adv.EnforceNetwork ||
        adv.EnforceGeo ||
        adv.EnforceDevice ||
        adv.EnforceCompanyEmail
      );
      if (
        hasAdvanced ||
        users.length > 0 ||
        restrictedType === "SelectedUsers" ||
        restrictedType.toLowerCase() !== "linkaccess"
      ) {
        const bits: string[] = [];
        if (users.length > 0) {
          bits.push(users.length === 1 ? "1 user" : `${users.length} users`);
        }
        if (adv.EnforceNetwork) bits.push("network");
        if (adv.EnforceGeo) bits.push("location");
        if (adv.EnforceDevice) bits.push("devices");
        if (adv.EnforceCompanyEmail) bits.push("email");
        return bits.length ? `Restricted · ${bits.join(", ")}` : "Restricted";
      }
      return "Anyone with the link";
    }
    return "Public";
  }

  getFlowAccessBadge(flow: any): string {
    const access = String(flow?.accessType || flow?.AccessType || "").toLowerCase();
    const restricted = String(
      flow?.restrictedAccessType || flow?.RestrictedAccessType || ""
    ).toLowerCase();
    if (access === "private") return "Private";
    if (access === "restricted") {
      if (restricted === "linkaccess") return "Link";
      if (restricted === "selectedusers") return "Restricted";
      return "Restricted";
    }
    return "Public";
  }

  private normalizeBundleAccessType(value: any): BundlePublishAccess {
    const access = String(value || "").toLowerCase();
    if (access === "private") {
      return "Private";
    }
    if (access === "restricted" || access === "linkaccess") {
      return "Restricted";
    }
    return "Public";
  }

  private inferAccessTypeFromFlows(flows: any[]): BundlePublishAccess {
    if (!Array.isArray(flows) || flows.length === 0) {
      return "Public";
    }
    const first = flows[0];
    const access = String(first?.accessType || first?.AccessType || "").toLowerCase();
    const restricted = String(
      first?.restrictedAccessType || first?.RestrictedAccessType || ""
    ).toLowerCase();
    if (access === "private") {
      return "Private";
    }
    if (access === "restricted" || restricted === "linkaccess") {
      return "Restricted";
    }
    return "Public";
  }

  private resolveBundleAccessTypeFromBundle(bundle: any): BundlePublishAccess {
    if (!bundle) {
      return "Public";
    }

    const restrictedType = String(
      bundle.restrictedAccessType || bundle.RestrictedAccessType || ""
    ).toLowerCase();

    const direct =
      bundle.bundleAccessType || bundle.accessType || bundle.AccessType;
    if (direct != null && `${direct}`.trim() !== "") {
      const normalized = this.normalizeBundleAccessType(direct);
      if (normalized === "Restricted" && restrictedType) {
        this.restrictedAccessType =
          bundle.restrictedAccessType || bundle.RestrictedAccessType || "";
        this.isSearchHidden =
          bundle.isSearchHidden ?? bundle.IsSearchHidden ?? false;
      }
      return normalized;
    }

    if (
      String(bundle.accessType || bundle.AccessType || "").toLowerCase() ===
        "restricted" ||
      restrictedType === "linkaccess"
    ) {
      this.restrictedAccessType =
        bundle.restrictedAccessType || bundle.RestrictedAccessType || "LinkAccess";
      this.isSearchHidden =
        bundle.isSearchHidden ?? bundle.IsSearchHidden ?? true;
      return "Restricted";
    }

    const flows = Array.isArray(bundle.flows) ? bundle.flows : [];
    if (flows.length > 0) {
      return this.inferAccessTypeFromFlows(flows);
    }

    return "Public";
  }

  private localDraftMatchesBundle(
    localDraft: any,
    bundleId: string,
    serverBundle: any
  ): boolean {
    if (!localDraft) {
      return false;
    }
    const draftKey =
      localDraft.rowKey || localDraft.id || localDraft.bundleId || "";
    const serverKey =
      serverBundle?.rowKey || serverBundle?.RowKey || bundleId || "";
    return draftKey && serverKey && `${draftKey}` === `${serverKey}`;
  }

  private applyBundleAccessTypeFromSources(
    serverBundle: any,
    bundleId: string
  ): BundlePublishAccess {
    let resolved = this.resolveBundleAccessTypeFromBundle(serverBundle);

    const serverFlows = Array.isArray(serverBundle?.flows)
      ? serverBundle.flows
      : [];
    if (resolved === "Public" && serverFlows.length > 0) {
      const inferred = this.inferAccessTypeFromFlows(serverFlows);
      if (inferred !== "Public") {
        resolved = inferred;
      }
    }

    return resolved;
  }

  private loadBundleAccessTypeAfterDetails(
    serverBundle: any,
    bundleId: string
  ): void {
    const rowKey =
      serverBundle?.rowKey || serverBundle?.RowKey || bundleId || "";
    let resolved = this.applyBundleAccessTypeFromSources(serverBundle, bundleId);

    if (resolved !== "Public" || !rowKey) {
      if (resolved === "Restricted") {
        this.hydrateBundleRestrictedSettings(serverBundle);
      }
      this.setBundleAccessTypeResolved(resolved);
      return;
    }

    this.flowServiceService.getAccessControl(rowKey).subscribe({
      next: (control) => {
        const access = String(
          control?.accessType || control?.AccessType || ""
        ).toLowerCase();
        const restricted = String(
          control?.restrictedAccessType || control?.RestrictedAccessType || ""
        ).toLowerCase();

        if (access === "private") {
          this.setBundleAccessTypeResolved("Private");
          return;
        }
        if (access === "restricted" || restricted === "linkaccess") {
          this.hydrateBundleRestrictedSettings(control);
          this.setBundleAccessTypeResolved("Restricted");
          return;
        }

        this.setBundleAccessTypeResolved(resolved);
      },
      error: () => this.setBundleAccessTypeResolved(resolved),
    });
  }

  private hydrateBundleRestrictedSettings(source: any): void {
    if (!source) {
      return;
    }
    this.restrictedAccessType =
      source.restrictedAccessType || source.RestrictedAccessType || "";
    this.isSearchHidden =
      source.isSearchHidden ?? source.IsSearchHidden ?? false;
    const flows =
      source.restrictedAccessFlows || source.RestrictedAccessFlows;
    if (flows) {
      this.savedAccessFlows = flows;
    }
    this.savedAccessAdvanced = {
      EnforceNetwork: source.enforceNetwork ?? source.EnforceNetwork ?? false,
      EnforceGeo: source.enforceGeo ?? source.EnforceGeo ?? false,
      EnforceDevice: source.enforceDevice ?? source.EnforceDevice ?? false,
      EnforceCompanyEmail:
        source.enforceCompanyEmail ?? source.EnforceCompanyEmail ?? false,
      AllowedCidrs: source.allowedCidrs ?? source.AllowedCidrs ?? "",
      GeoFenceJson: source.geoFenceJson ?? source.GeoFenceJson ?? null,
      AllowedDeviceIds:
        source.allowedDeviceIds ?? source.AllowedDeviceIds ?? "",
      AllowedEmailDomains:
        source.allowedEmailDomains ?? source.AllowedEmailDomains ?? "",
    };
  }

  private setBundleAccessTypeResolved(resolved: BundlePublishAccess): void {
    this.bundleAccessType = resolved;
    this.updateFlowSearchInformation();
    this.persistBundleAccessTypeToLocalDetails();
    this.cdr.detectChanges();
  }

  isBundleAccessTypeSelected(accessType: BundlePublishAccess): boolean {
    return this.bundleAccessType === accessType;
  }

  private persistableBundleAccessType(
    accessType: BundlePublishAccess = this.bundleAccessType
  ): "Public" | "Private" | "Restricted" {
    if (accessType === "Private") {
      return "Private";
    }
    if (accessType === "Restricted") {
      return "Restricted";
    }
    return "Public";
  }

  private buildRestrictedBundleFields(): Record<string, any> {
    if (this.bundleAccessType !== "Restricted") {
      return {
        restrictedAccessType: null,
        isSearchHidden: this.bundleAccessType !== "Public",
      };
    }
    const adv = this.savedAccessAdvanced || {};
    const restrictedFlows = (this.savedAccessFlows || []).map((u: any) => ({
      EmailAddress: u.emailAddress || u.EmailAddress,
      UserName: u.userName || u.UserName,
      FirstName: u.firstName || u.FirstName,
      ProfilePicUrl: u.profilePicUrl || u.ProfilePicUrl,
    }));
    return {
      restrictedAccessType: this.restrictedAccessType || null,
      isSearchHidden: this.isSearchHidden,
      restrictedAccessFlows: restrictedFlows,
      EnforceNetwork: adv.EnforceNetwork || false,
      EnforceGeo: adv.EnforceGeo || false,
      EnforceDevice: adv.EnforceDevice || false,
      EnforceCompanyEmail: adv.EnforceCompanyEmail || false,
      AllowedCidrs: adv.AllowedCidrs || "",
      GeoFenceJson: adv.GeoFenceJson || null,
      AllowedDeviceIds: adv.AllowedDeviceIds || "",
      AllowedEmailDomains: adv.AllowedEmailDomains || "",
    };
  }

  /** Account the picker lists guides from: the pack's (or active) organization, else personal content. */
  private pickerScope(): { accountScope: string; organizationId?: string } {
    const d: any = this.bundleData || {};
    const organizationId =
      d.organizationId || d.OrganizationId || this.orgContext.contentScope().organizationId || null;
    return organizationId
      ? { accountScope: "Organization", organizationId }
      : { accountScope: "Personal" };
  }

  private inPickerScope(flow: any): boolean {
    const scope = this.pickerScope();
    const flowOrgId = `${flow?.organizationId || flow?.OrganizationId || ""}`.trim().toLowerCase();
    return scope.accountScope === "Organization"
      ? flowOrgId === `${scope.organizationId}`.trim().toLowerCase()
      : !flowOrgId;
  }

  private queryAccessTypeForFlows(): string {
    if (!this.showMatchingAccessOnly) {
      return "All";
    }
    if (this.bundleAccessType === "Restricted") {
      const rt = String(this.restrictedAccessType || "").toLowerCase();
      if (rt === "linkaccess") {
        return "LinkAccess";
      }
      return "Restricted";
    }
    return this.bundleAccessType;
  }

  /** Org guide packs are published through the approval flow, not directly. */
  get requiresOrgApproval(): boolean {
    const d: any = this.bundleData || {};
    return !!(
      d.organizationId ||
      d.OrganizationId ||
      this.orgContext.contentScope().organizationId
    );
  }

  publishBundle(): void {
    if (this.requiresOrgApproval) {
      this.toastr.info("Submit this guide pack for approval to publish it in your organization.");
      return;
    }
    this.saveFlowToServerAccessLevel(this.bundleAccessType);
  }

  private persistBundleAccessTypeToLocalDetails(): void {
    try {
      const raw = localStorage.getItem("createbundledetails");
      const existing = raw ? JSON.parse(raw) : {};
      existing.accessType = this.bundleAccessType;
      existing.bundleAccessType = this.bundleAccessType;
      existing.restrictedAccessType = this.restrictedAccessType;
      existing.isSearchHidden = this.isSearchHidden;
      existing.restrictedAccessFlows = this.savedAccessFlows;
      existing.savedAccessAdvanced = this.savedAccessAdvanced;
      const rowKey =
        this.bundleData?.rowKey ||
        this.bundleData?.RowKey ||
        this.bundleId ||
        "";
      if (rowKey) {
        existing.rowKey = rowKey;
        existing.bundleId = rowKey;
      }
      localStorage.setItem("createbundledetails", JSON.stringify(existing));
    } catch {
      /* ignore */
    }
  }

  getApprovedFlows(): void {
    this.tempFlows = [];
    localStorage.removeItem("addbundlePageIndex");
    localStorage.setItem("addbundlePageIndex", "0");
    this.callServiceForApprovedFlows("0");
  }

  callServiceForApprovedFlows(pageIndex) {
    this.flowSearchNoResultReturned = true;
    this.openLoadingModal("Loading flows...", false);

    var flowQueryModel = new FlowQueryModel({
      userEmail: this.userData.emailAddress,
      pageIndex: pageIndex,
      accessType: this.queryAccessTypeForFlows(),
      ...this.pickerScope(),
    });

    this.flowServiceService.getAllUserFlows(flowQueryModel).subscribe({
      next: (data) => {
        this.flowSearchNoResultReturned = false;
        this.closeLoadingModal();
        if (data.flows.length > 0) {
          data.flows.filter((f) => this.inPickerScope(f)).forEach((element) => {
            this.tempFlows.push({ flow: element, isSelected: false });
          });

          // Mark already selected flows
          if (
            this.bundleFlows != null &&
            this.bundleFlows.length > 0
          ) {
            this.bundleFlows.forEach((element: any) => {
              let flow = this.tempFlows.filter(
                (f) => f.flow.rowKey == element.flow.rowKey
              )[0];
              if (flow != null && flow != undefined) flow.isSelected = true;
            });
          }
        }
        if (String(pageIndex) === "0") {
          this.appendOrgTeamGuidesToPicker();
        }
      },
      error: (error) => {
        this.flowSearchNoResultReturned = false;
        this.closeLoadingModal();
        this.toastr.error("Failed to load flows. Please try again.");
        console.error("Error loading flows:", error);
        if (String(pageIndex) === "0") {
          this.appendOrgTeamGuidesToPicker();
        }
      },
    });
  }

  private loadOrgTeamGuides(): Observable<any[]> {
    if (!this.orgTeamGuides$) {
      const d: any = this.bundleData || {};
      const organizationId =
        d.organizationId || d.OrganizationId || this.orgContext.contentScope().organizationId;
      if (!organizationId) return of([]);
      // No app/team filter: the server already limits results to what this member may see.
      this.orgTeamGuides$ = this.flowServiceService
        .getOrgTeamGuides({ organizationId })
        .pipe(
          map((data) => (Array.isArray(data?.flows) ? data.flows : [])),
          catchError(() => {
            this.orgTeamGuides$ = null;
            return of([]);
          }),
          shareReplay(1)
        );
    }
    return this.orgTeamGuides$;
  }

  private orgGuideMatchesPickerFilters(flow: any, searchTerm: string): boolean {
    const wanted = this.queryAccessTypeForFlows();
    if (wanted && wanted !== "All") {
      const actual = String(flow?.accessType || "Public").toLowerCase();
      const target = wanted === "LinkAccess" ? "restricted" : wanted.toLowerCase();
      if (actual !== target) return false;
    }
    const q = (searchTerm || "").trim().toLowerCase();
    if (!q) return true;
    return [flow?.title, flow?.uniqueId, flow?.userName, flow?.description].some((v) =>
      String(v || "").toLowerCase().includes(q)
    );
  }

  /** Adds other members' published guides to the guide picker (deduplicated). */
  private appendOrgTeamGuidesToPicker(searchTerm: string = ""): void {
    const target = this.tempFlows;
    this.loadOrgTeamGuides().subscribe((guides) => {
      if (target !== this.tempFlows || !guides.length) return;
      const existing = new Set(target.map((t) => `${t?.flow?.rowKey || ""}`));
      const selected = new Set(
        (this.bundleFlows || []).map((s: any) => `${s?.flow?.rowKey || ""}`)
      );
      guides.forEach((guide) => {
        const id = `${guide?.rowKey || ""}`;
        if (!id || existing.has(id) || !this.orgGuideMatchesPickerFilters(guide, searchTerm)) {
          return;
        }
        existing.add(id);
        target.push({ flow: guide, isSelected: selected.has(id) });
      });
      this.cdr.detectChanges();
    });
  }

  performFlowSearch(pageIndex: number) {
    if (
      this.searchInput == "" ||
      this.searchInput == undefined ||
      this.searchInput == null
    ) {
      this.getApprovedFlows();
    } else {
      this.tempFlows = [];
      localStorage.removeItem("addbundlePageIndex");
      localStorage.setItem("addbundlePageIndex", "0");

      this.flowSearchNoResultReturned = true;
      this.openLoadingModal("Searching flows...", false);

      var flowQueryModel = new FlowQueryModel({
        searchString: this.searchInput,
        userEmail: this.userData.emailAddress,
        pageIndex: pageIndex,
        accessType: this.queryAccessTypeForFlows(),
        ...this.pickerScope(),
      });

      this.flowServiceService.searchInFlows(flowQueryModel).subscribe({
        next: (data) => {
          this.tempFlows = [];
          this.flowSearchNoResultReturned = false;
          this.closeLoadingModal();
          if (data.flows != null && data.flows != undefined) {
            data.flows.filter((f) => this.inPickerScope(f)).forEach((element) => {
              this.tempFlows.push({ flow: element, isSelected: false });
            });

            // Mark already selected flows
            if (
              this.bundleFlows != null &&
              this.bundleFlows.length > 0
            ) {
              this.bundleFlows.forEach((element: any) => {
                let flow = this.tempFlows.filter(
                  (f) => f.flow.rowKey == element.flow.rowKey
                )[0];
                if (flow != null && flow != undefined) flow.isSelected = true;
              });
            }
          }
          this.appendOrgTeamGuidesToPicker(flowQueryModel.searchString);
        },
        error: (error) => {
          this.tempFlows = [];
          this.flowSearchNoResultReturned = false;
          this.closeLoadingModal();
          this.toastr.error("Failed to search flows. Please try again.");
          console.error("Error searching flows:", error);
          this.appendOrgTeamGuidesToPicker(flowQueryModel.searchString);
        },
      });
    }
  }

  // selectFiles(event, source) {
  //   if (event.target.files) {
  //     this.noResultReturned = true;
  //     //
  //     this.fileData = <File>event.target.files[0];
  //     const formData = new FormData();
  //     formData.append("fileData", this.fileData);

  //     // this.isStepCoverPageURISet = true;
  //     this.isAddSupportingDocument = true;
  //     if (
  //       this.fileData.name.includes("JPEG") ||
  //       this.fileData.name.includes("jpeg") ||
  //       this.fileData.name.includes("png") ||
  //       this.fileData.name.includes("jpg") ||
  //       this.fileData.name.includes("PNG") ||
  //       this.fileData.name.includes("JFIF") ||
  //       this.fileData.name.includes("jfif") ||
  //       this.fileData.name.includes("TIFF") ||
  //       this.fileData.name.includes("tiff") ||
  //       this.fileData.name.includes("TIF") ||
  //       this.fileData.name.includes("tif") ||
  //       this.fileData.name.includes("JPG") ||
  //       this.fileData.name.includes("pdf") ||
  //       this.fileData.name.includes("PDF")
  //     ) {
  //       this.http
  //         .post(
  //           environment.apiBaseUrl + environment.uploadImageUrl,
  //           formData
  //         )
  //         .subscribe((data) => {
  //           var mediaUploadStatus = data as any;
  //           this.showImage = true;
  //           this.showVideo = false;
  //           this.noResultReturned = false;

  //           if (mediaUploadStatus != null) {
  //             if (source == "cp") {
  //               this.fileName = this.fileData.name;
  //               this.bundleImageUrl =
  //                 environment.imageStorageBaseUrl +
  //                 mediaUploadStatus.fileName;
  //             } else if (source == "sd") {
  //               this.sffilelink = mediaUploadStatus.fileName;
  //             }
  //             if(this.bundleImageUrl !=null && this.bundleImageUrl !=undefined){
  //               this.bundleData.url=this.bundleImageUrl;
  //             }else{
  //               this.bundleData.url=this.sffilelink;
  //             }
  //           } else {
  //             alert(mediaUploadStatus.message);
  //           }
  //         });
  //     } else if (
  //       this.fileData.name.includes("MP4") ||
  //       this.fileData.name.includes("mp4") ||
  //       this.fileData.name.includes("MOV") ||
  //       this.fileData.name.includes("mov") ||
  //       this.fileData.name.includes("WMV") ||
  //       this.fileData.name.includes("wmv") ||
  //       this.fileData.name.includes("FLV") ||
  //       this.fileData.name.includes("flv") ||
  //       this.fileData.name.includes("AVCHD") ||
  //       this.fileData.name.includes("avchd") ||
  //       this.fileData.name.includes("WEBM") ||
  //       this.fileData.name.includes("webm") ||
  //       this.fileData.name.includes("MKV") ||
  //       this.fileData.name.includes("mkv") ||
  //       this.fileData.name.includes("VOB") ||
  //       this.fileData.name.includes("vob") ||
  //       this.fileData.name.includes("OGV") ||
  //       this.fileData.name.includes("ogv") ||
  //       this.fileData.name.includes("GIFY") ||
  //       this.fileData.name.includes("gifv") ||
  //       this.fileData.name.includes("M4P") ||
  //       this.fileData.name.includes("m4p") ||
  //       this.fileData.name.includes("M4V") ||
  //       this.fileData.name.includes("m4v") ||
  //       this.fileData.name.includes("3GP") ||
  //       this.fileData.name.includes("3gp") ||
  //       this.fileData.name.includes("3G2") ||
  //       this.fileData.name.includes("3g2") ||
  //       this.fileData.name.includes("AMV") ||
  //       this.fileData.name.includes("amv") ||
  //       this.fileData.name.includes("NSV") ||
  //       this.fileData.name.includes("nsv") ||
  //       this.fileData.name.includes("OGG") ||
  //       this.fileData.name.includes("ogg") ||
  //       this.fileData.name.includes("FLV") ||
  //       this.fileData.name.includes("flv") ||
  //       this.fileData.name.includes("F4V") ||
  //       this.fileData.name.includes("f4v") ||
  //       this.fileData.name.includes("F4P") ||
  //       this.fileData.name.includes("f4p") ||
  //       this.fileData.name.includes("F4A") ||
  //       this.fileData.name.includes("f4a") ||
  //       this.fileData.name.includes("F4B") ||
  //       this.fileData.name.includes("f4b")
  //     ) {
  //       this.http
  //         .post(
  //           environment.apiBaseUrl + environment.uploadVideoUrl,
  //           formData
  //         )
  //         .subscribe((data) => {
  //           var mediaUploadStatus = data as any;
  //           this.showVideo = true;
  //           this.showImage = false;
  //           this.noResultReturned = false;
  //           if (mediaUploadStatus != null) {
  //             if (source == "cp") {
  //               this.fileName = this.fileData.name;
  //               this.bundleImageUrl =
  //                 environment.videoStorageBaseUrl +
  //                 mediaUploadStatus.fileName;
  //             } else if (source == "sd") {
  //               this.sffilelink = mediaUploadStatus.fileName;
  //             }

  //             if(this.bundleImageUrl !=null && this.bundleImageUrl !=undefined){
  //               this.bundleData.url=this.bundleImageUrl;
  //             }else{
  //               this.bundleData.url=this.sffilelink;
  //             }
  //           } else {
  //             alert(mediaUploadStatus.message);
  //           }
  //         });
  //     }
  //   }

  //   console.log(this.bundleData);
  // }

  async selectFiles(event: any) {
    if (event.target.files) {
      this.noResultReturned = true;
      this.fileData = <File>event.target.files[0];
      this.fileName = this.fileData.name;
      this.isLoading = true; // Add loading state

      // File extensions for images and videos
      const imageExtensions = ["jpeg", "png", "jpg", "jfif", "tiff", "tif"];
      const videoExtensions = [
        "mp4",
        "mov",
        "wmv",
        "flv",
        "avchd",
        "webm",
        "mkv",
        "vob",
        "ogv",
        "gifv",
        "m4p",
        "m4v",
        "3gp",
        "3g2",
        "amv",
        "nsv",
        "ogg",
        "f4v",
        "f4p",
        "f4a",
        "f4b",
      ];

      // Convert file extension to lowercase and check type
      const fileNameLower = this.fileData.name.toLowerCase();
      const isImage = imageExtensions.some((ext) =>
        fileNameLower.endsWith(ext)
      );
      const isVideo = videoExtensions.some((ext) =>
        fileNameLower.endsWith(ext)
      );

      let fileToUpload = this.fileData;
      if (isVideo) {
        try {
          fileToUpload = await this.mediaUploadService.prepareFileForUpload(this.fileData);
          this.fileData = fileToUpload;
        } catch (error: any) {
          this.isLoading = false;
          this.noResultReturned = false;
          this.fileName = "";
          this.toastr.warning(error?.message || this.mediaUploadService.uploadTooLargeMessage());
          return;
        }
      }

      const formData = new FormData();
      formData.append("fileData", fileToUpload);

      // Set the upload URL
      const uploadUrl = isImage
        ? environment.apiBaseUrl + environment.uploadImageUrl
        : environment.apiBaseUrl + environment.uploadVideoUrl;

      this.http
        .post(uploadUrl, formData, { reportProgress: true, observe: "events" })
        .subscribe(
          (event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.UploadProgress:
                if (event.total !== undefined) {
                  const progress = (event.loaded / event.total) * 100;
                  if (progress !== 100) {
                    this.progress = progress;
                  }
                }
                break;
              case HttpEventType.Response:
                this.handleFileUpload(event, isImage);
                break;
            }
          },
          (error) => {
            this.isLoading = false;
            this.noResultReturned = false;
            this.fileName = "";
            this.toastr.warning(this.mediaUploadService.uploadTooLargeMessage());
            console.error("An error occurred:", error);
          }
        );
    }
  }

  handleFileUpload(res: HttpResponse<any>, isImage: boolean) {
    this.isLoading = false;
    this.noResultReturned = false;
    const mediaUploadStatus = res.body;
    // this.sffilelink = mediaUploadStatus.fileName;

    if (mediaUploadStatus) {
      if (isImage) {
        this.showImage = true;
        this.showVideo = false;
        this.bundleImageUrl =
          environment.imageStorageBaseUrl + mediaUploadStatus.fileName;
      } else {
        this.showVideo = true;
        this.showImage = false;
        this.bundleImageUrl =
          environment.videoStorageBaseUrl + mediaUploadStatus.fileName;
        // this.posterUrl = environment.imageStorageBaseUrl + mediaUploadStatus.posterImageName;
      }
      this.toastr.success("File has been uploaded successfully.");
      this.progress = 100;
      if (this.bundleImageUrl != null && this.bundleImageUrl != undefined) {
        this.bundleData.url = this.bundleImageUrl;
        this.isImageOrVideo(this.bundleData.url);
      } else {
        this.bundleData.url = this.sffilelink;
      }
    } else {
      this.toastr.error("Upload failed.");
    }
  }

  leave() {
    this.flowNavigationService.navigateBackFromBundle(this.bundleData?.rowKey);
  }

  confirmLeave(): void {
    const ref = this.dialog.open(LeaveConfirmationDialogComponent, {
      width: "420px",
      maxWidth: "95vw",
      data: {
        title: "Unsaved changes",
        message:
          "You have unsaved changes. If you leave now your changes will be lost.",
      },
      panelClass: "quick-create-stacked-dialog",
      backdropClass: "quick-create-stacked-dialog-backdrop",
    });

    ref.afterClosed().subscribe((leave: boolean) => {
      if (leave) {
        this.leave();
      }
    });
  }

  showBundleVideo: boolean;
  showCoverImage: boolean;
  showCoverVideo: boolean;

  isCoverAImageOrVideo(url) {
    if (
      url.includes("JPEG") ||
      url.includes("jpeg") ||
      url.includes("JPG") ||
      url.includes("JFIF") ||
      url.includes("PNG") ||
      url.includes("jfif") ||
      url.includes("png") ||
      url.includes("tiff") ||
      url.includes("TIFF") ||
      url.includes("TIF") ||
      url.includes("tif") ||
      url.includes("jpg")
    ) {
      this.showCoverImage = true;
      this.showCoverVideo = false;
    } else if (
      url.includes("MP4") ||
      url.includes("mp4") ||
      url.includes("MOV") ||
      url.includes("mov") ||
      url.includes("WMV") ||
      url.includes("wmv") ||
      url.includes("FLV") ||
      url.includes("flv") ||
      url.includes("AVCHD") ||
      url.includes("avchd") ||
      url.includes("WEBM") ||
      url.includes("webm") ||
      url.includes("MKV") ||
      url.includes("mkv") ||
      url.includes("VOB") ||
      url.includes("vob") ||
      url.includes("OGV") ||
      url.includes("ogv") ||
      url.includes("GIFY") ||
      url.includes("gifv") ||
      url.includes("M4P") ||
      url.includes("m4p") ||
      url.includes("M4V") ||
      url.includes("m4v") ||
      url.includes("3GP") ||
      url.includes("3gp") ||
      url.includes("3G2") ||
      url.includes("3g2") ||
      url.includes("AMV") ||
      url.includes("amv") ||
      url.includes("NSV") ||
      url.includes("nsv") ||
      url.includes("OGG") ||
      url.includes("ogg") ||
      url.includes("FLV") ||
      url.includes("flv") ||
      url.includes("F4V") ||
      url.includes("f4v") ||
      url.includes("F4P") ||
      url.includes("f4p") ||
      url.includes("F4A") ||
      url.includes("f4a") ||
      url.includes("F4B") ||
      url.includes("f4b")
    ) {
      this.showCoverVideo = true;
      this.showCoverImage = false;
    }
  }

  deleteBundle(item, index) {
    this.bundleFlows.splice(index, 1);
    localStorage.setItem(
      "addbundleselectedflows",
      JSON.stringify(this.bundleFlows)
    );

    if (this.bundleFlows.length >= 2) {
      this.bFlows = true;
    } else {
      this.bFlows = false;
    }
  }

  editLink(index, link) {
    this.linkName = link.linkName;
    this.hyperLink = link.linkUrl;
    localStorage.setItem("editBundlesupportingDocumentHyperLinksIndex", index);
  }

  addLink() {
    var editsupportingDocumentHyperLinksIndex = localStorage.getItem(
      "editBundlesupportingDocumentHyperLinksIndex"
    );
    if (editsupportingDocumentHyperLinksIndex != null) {
      this.bundleData.flowSupportingDocumentsHyperLinkModels.splice(
        parseInt(editsupportingDocumentHyperLinksIndex),
        1
      );

      var slink = {
        linkName: this.linkName,
        linkUrl: this.hyperLink,
      };
      this.bundleData.flowSupportingDocumentsHyperLinkModels.splice(
        parseInt(editsupportingDocumentHyperLinksIndex),
        0,
        slink
      );
    } else {
      this.bundleData.flowSupportingDocumentsHyperLinkModels.push({
        linkName: this.linkName,
        linkUrl: this.hyperLink,
      });
    }

    this.linkName = "";
    this.hyperLink = "";
    localStorage.setItem(
      "BundleSupportingDocumentHyperLinksRequired",
      JSON.stringify(this.supportingDocumentHyperLinks)
    );
    localStorage.removeItem("editBundlesupportingDocumentHyperLinksIndex");
  }

  addSupportingDocument() {
    var editSupportingDocumentRequiredIndex = localStorage.getItem(
      "editBundleSupportingDocumentRequiredIndex"
    );

    if (editSupportingDocumentRequiredIndex != null) {
      this.bundleData.flowSupportingDocumentsDocumentModels.splice(
        parseInt(editSupportingDocumentRequiredIndex),
        1
      );

      var document = {
        documentName: this.documentName,
        documentUrl: this.sffilelink,
      };

      this.bundleData.flowSupportingDocumentsDocumentModels.splice(
        parseInt(editSupportingDocumentRequiredIndex),
        0,
        document
      );
    } else {
      this.bundleData.flowSupportingDocumentsDocumentModels.push({
        documentName: this.documentName,
        documentUrl: this.sffilelink,
      });
    }
    this.documentName = "";
    this.sffilelink = "";

    localStorage.setItem(
      "BundleSupportingDocumentDocuments",
      JSON.stringify(this.bundleData?.flowSupportingDocumentsDocumentModels || [])
    );
    localStorage.removeItem("editBundleSupportingDocumentRequiredIndex");

    this.totalSupportingDocuments =
      (this.bundleData?.flowSupportingDocumentsHyperLinkModels?.length || 0) +
      (this.bundleData?.flowSupportingDocumentsDocumentModels?.length || 0);
  }

  editSupportingDocument(index, document) {
    this.documentName = document.documentName;
    this.sffilelink = document.documentUrl;
    localStorage.setItem("editBundleSupportingDocumentRequiredIndex", index);
  }

  tabChanged(tabChangedEvent) {}

  remove(index) {
    if (this.bundleData?.flowSupportingDocumentsDocumentModels) {
      this.bundleData.flowSupportingDocumentsDocumentModels.splice(index, 1);
    }

    localStorage.setItem(
      "SupportingDocumentDocuments",
      JSON.stringify(this.bundleData?.flowSupportingDocumentsDocumentModels || [])
    );

    this.totalSupportingDocuments =
      (this.bundleData?.flowSupportingDocumentsHyperLinkModels?.length || 0) +
      (this.bundleData?.flowSupportingDocumentsDocumentModels?.length || 0);
  }

  removeLink(index) {
    if (this.bundleData?.flowSupportingDocumentsHyperLinkModels) {
      this.bundleData.flowSupportingDocumentsHyperLinkModels.splice(index, 1);
    }
    localStorage.setItem(
      "SupportingDocumentHyperLinksRequired",
      JSON.stringify(this.bundleData?.flowSupportingDocumentsHyperLinkModels || [])
    );
  }

  GoToOriginalTitleText() {
    this.bundleData.title = this.originalTitleText;
  }

  openRephraseDialog() {
    const dialogRef = this.dialog.open(SelectionRephraseAIComponent, {
      width: "400px",
      data: { textToRephrase: this.bundleData.title }, // Pass the text to the dialog
    });
    if (!this.isTitleRephrased) {
      this.originalTitleText = this.bundleData.title;
    }
    this.isTitleRephraseInProgress = true;
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // Update the title with the rephrased text and show the selected style
        this.bundleData.title = result.rephrasedText;
        console.log("Selected style:", result.selectedStyle);
        this.isTitleRephrased = true;
        this.isTitleRephraseInProgress = false;
      }
    });
  }

  GoToOriginalText() {
    this.bundleData.description = this.originalContentTitleText;
  }

  openDescrptionRephraseDialog() {
    const dialogRef = this.dialog.open(SelectionRephraseAIComponent, {
      width: "400px",
      data: { textToRephrase: this.bundleData.description }, // Pass the text to the dialog
    });
    if (!this.isRephrased) {
      this.originalContentTitleText = this.bundleData.description;
      console.log(this.description);
    }
    this.isRephraseInProgress = true;
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // Update the title with the rephrased text and show the selected style
        this.bundleData.description = result.rephrasedText;
        console.log("Selected style:", result.selectedStyle);
        this.isRephrased = true;
        this.isRephraseInProgress = false;
      }
    });
  }

  // Journey tab navigation methods
  setActiveBundleJourneyTab(tabId: BundleJourneyTabId) {
    // Mark the previous tab as visited when navigating away from it
    const previousTab = this.activeBundleJourneyTab;
    if (previousTab && previousTab !== tabId) {
      this.visitedBundleTabs.add(previousTab);
    }
    
    this.activeBundleJourneyTab = tabId;
    // Mark the current tab as visited since user is viewing it
    this.visitedBundleTabs.add(tabId);
  }

  isBundleJourneyStageActive(tabId: BundleJourneyTabId): boolean {
    return this.activeBundleJourneyTab === tabId;
  }

  isBundleJourneyStageComplete(tabId: BundleJourneyTabId): boolean {
    // Mark a tab green once it's been visited (even if optional data wasn't added),
    // as long as it's not the currently active tab.
    return this.visitedBundleTabs.has(tabId) && tabId !== this.activeBundleJourneyTab;
  }

  canAccessBundleJourneyTab(tabId: BundleJourneyTabId): boolean {
    const tabIndex = this.bundleJourneyTabs.findIndex((t) => t.id === tabId);
    if (tabIndex === 0) return true;
    // Allow access to previous tabs
    // Skip documents tab validation as it's optional
    for (let i = 0; i < tabIndex; i++) {
      const currentTab = this.bundleJourneyTabs[i];
      // Skip documents tab - it's optional and doesn't block navigation
      if (currentTab.id === "documents") {
        continue;
      }
      if (!this.isBundleJourneyStageComplete(currentTab.id)) {
        return false;
      }
    }
    return true;
  }

  getBundleJourneyTabIndex(tabId: BundleJourneyTabId): number {
    return this.bundleJourneyTabs.findIndex((t) => t.id === tabId);
  }

  goToNextBundleJourneyTab() {
    const currentIndex = this.getBundleJourneyTabIndex(
      this.activeBundleJourneyTab
    );
    if (currentIndex < this.bundleJourneyTabs.length - 1) {
      const nextTab = this.bundleJourneyTabs[currentIndex + 1];
      if (this.canAccessBundleJourneyTab(nextTab.id)) {
        this.setActiveBundleJourneyTab(nextTab.id);
      }
    }
  }

  get isLastBundleJourneyTab(): boolean {
    return (
      this.getBundleJourneyTabIndex(this.activeBundleJourneyTab) ===
      this.bundleJourneyTabs.length - 1
    );
  }

  getActiveBundleTabLabel(): string {
    const activeTab = this.bundleJourneyTabs.find(
      (tab) => tab.id === this.activeBundleJourneyTab
    );
    return activeTab ? activeTab.label : "Section";
  }

  // Loading modal helper methods
  openLoadingModal(message: string, showProgress: boolean = false) {
    if (this.loadingModalRef) {
      this.closeLoadingModal();
    }
    this.loadingModalRef = this.dialog.open(LoadingModalComponent, {
      width: "400px",
      disableClose: true,
      data: {
        message: message,
        progress: 0,
        showProgress: showProgress,
      } as LoadingModalData,
    });
  }

  updateLoadingModal(message?: string, progress?: number) {
    if (this.loadingModalRef && this.loadingModalRef.componentInstance) {
      if (message) {
        this.loadingModalRef.componentInstance.updateMessage(message);
      }
      if (progress !== undefined) {
        this.loadingModalRef.componentInstance.updateProgress(progress);
      }
    }
  }

  closeLoadingModal() {
    if (this.loadingModalRef) {
      this.loadingModalRef.close();
      this.loadingModalRef = null;
    }
  }

  // Additional helper methods for edit bundle
  isImageOrVideo(url: string) {
    if (!url) {
      this.showImage = false;
      this.showVideo = false;
      return;
    }

    const imageExtensions = [
      "jpeg", "jpg", "png", "gif", "jfif", "tiff", "tif", "pdf",
      "bmp", "webp", "svg", "heic", "heif", "raw", "arw", "cr2",
      "nef", "orf", "rw2", "dng", "psd", "ico", "exif", "pjpeg",
      "ppm", "pgm", "pbm", "pnm", "xpm", "tga", "pcx", "jp2",
      "jpx", "eps", "ai"
    ];

    const videoExtensions = [
      "mp4", "mov", "wmv", "flv", "avchd", "webm", "mkv", "vob",
      "ogv", "gifv", "m4p", "m4v", "3gp", "3g2", "amv", "nsv",
      "ogg", "f4v", "f4p", "f4a", "f4b", "avi", "mts", "m2ts",
      "ts", "mpg", "mpeg", "rm", "rmvb", "divx", "xvid", "asf",
      "mxf", "dv", "h264", "h265", "vp8", "vp9", "prores", "swf",
      "dat", "bik", "av1", "vro", "svi"
    ];

    const isImage = imageExtensions.some((ext) =>
      url.toLowerCase().includes(ext.toLowerCase())
    );
    const isVideo = videoExtensions.some((ext) =>
      url.toLowerCase().includes(ext.toLowerCase())
    );

    if (isImage) {
      this.showImage = true;
      this.showVideo = false;
      return;
    }

    if (isVideo) {
      this.showVideo = true;
      this.showImage = false;
      return;
    }

    this.showImage = false;
    this.showVideo = false;
  }

  descChanged() {
    // Description changed handler
  }

  autoSaveCoverPageData() {
    // Auto-save functionality can be added here
  }

  showFlowImage(url: string) {
    // Show flow image in modal or full screen
  }

  closeAddFlowsPopup() {
    // Save selected flows
    var selectedFlows = this.tempFlows.filter((f) => f.isSelected);
    if (selectedFlows.length > 0) {
      // Merge with existing flows, avoiding duplicates
      selectedFlows.forEach((newFlow) => {
        const exists = this.bundleFlows.some(
          (existing) => existing.flow.rowKey === newFlow.flow.rowKey
        );
        if (!exists) {
          this.bundleFlows.push(newFlow);
        }
      });
      localStorage.setItem(
        "addbundleselectedflows",
        JSON.stringify(this.bundleFlows)
      );
      if (this.bundleFlows.length >= 2) {
        this.bFlows = true;
      } else {
        this.bFlows = false;
      }
    }
    this.showAddFlowsPopup = false;
    this.cdr.detectChanges();
  }

  onFlowScroll() {
    var pageIndex = localStorage.getItem("addbundlePageIndex");
    pageIndex = (parseInt(pageIndex) + 1).toString();
    localStorage.setItem("addbundlePageIndex", pageIndex);

    if (
      this.searchInput == "" ||
      this.searchInput == undefined ||
      this.searchInput == null
    ) {
      this.callServiceForApprovedFlows(pageIndex);
    } else {
      this.performFlowSearch(parseInt(pageIndex));
    }
  }

  searchFlows() {
    this.flowSearchTerms.next("");
  }

  // Thumbnail methods
  openThumbnailDialog(mode: "auto" | "upload" | "compare") {
    this.thumbnailDialogMode = mode;
    this.setThumbnailSelectionMode(mode);
    this.isThumbnailDialogOpen = true;

    if (mode === "auto") {
      this.selectedAutoThumbnailUrl = "";
      this.selectedAutoThumbnailFile = null;
    }

    if (mode === "auto" && this.showVideo && this.bundleData?.url) {
      setTimeout(() => {
        this.extractFirstThreeFrames();
      }, 300);
    }
  }

  closeThumbnailDialog() {
    this.isThumbnailDialogOpen = false;
  }

  setThumbnailSelectionMode(mode: "auto" | "upload" | "compare") {
    this.thumbnailSelectionMode = mode;
  }

  triggerThumbnailUploadDialog() {
    this.thumbnailSelectionMode = "upload";
    if (this.thumbnailUploadInput) {
      this.thumbnailUploadInput.nativeElement.value = "";
      this.thumbnailUploadInput.nativeElement.click();
    }
  }

  onCustomCoverThumbnailSelect(event: any) {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      if (file.size > 2 * 1024 * 1024) {
        this.toastr.warning("File size must be less than 2MB");
        return;
      }
      this.customCoverThumbnailFile = file;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.customCoverThumbnailUrl = e.target.result;
        this.thumbnailSelectionMode = "upload";
        this.uploadCustomCoverThumbnail();
      };
      reader.readAsDataURL(this.customCoverThumbnailFile);
    }
  }

  uploadCustomCoverThumbnail() {
    if (!this.customCoverThumbnailFile) {
      this.toastr.warning("Please select a thumbnail image");
      return;
    }

    this.customCoverThumbnailUploading = true;
    this.coverThumbnailUploadProgress = 0;
    this.openLoadingModal("Uploading thumbnail...", true);
    const formData = new FormData();
    formData.append("fileData", this.customCoverThumbnailFile);

    this.http
      .post(environment.apiBaseUrl + environment.uploadImageUrl, formData, {
        reportProgress: true,
        observe: "events",
      })
      .subscribe(
        (event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              if (event.total) {
                this.coverThumbnailUploadProgress = Math.round(
                  (event.loaded / event.total) * 100
                );
                this.updateLoadingModal(
                  "Uploading thumbnail...",
                  this.coverThumbnailUploadProgress
                );
              }
              break;
            case HttpEventType.Response:
              const response = event.body;
              if (response && response.fileName) {
                this.customCoverThumbnailUrl =
                  environment.imageStorageBaseUrl + response.fileName;
                this.coverPosterPageURI = this.customCoverThumbnailUrl;
                this.thumbnailSelectionMode = "upload";
                this.customCoverThumbnailFile = null;
                this.customCoverThumbnailUploading = false;
                this.closeLoadingModal();
                this.toastr.success("Custom thumbnail uploaded successfully");
                this.autoSaveCoverPageData();
              }
              break;
          }
        },
        (error) => {
          this.customCoverThumbnailUploading = false;
          this.closeLoadingModal();
          this.toastr.error("Failed to upload thumbnail");
          console.error("Upload error:", error);
        }
      );
  }

  onVideoMetadataLoaded() {
    if (this.coverVideoPlayer?.nativeElement) {
      const video = this.coverVideoPlayer.nativeElement;
      if (!video.crossOrigin) {
        video.crossOrigin = "anonymous";
      }
      this.videoDuration = video.duration;
    }
  }

  onVideoTimeUpdate() {
    if (this.coverVideoPlayer?.nativeElement) {
      this.currentVideoTime = this.coverVideoPlayer.nativeElement.currentTime;
    }
  }

  onScrubberChange(event: any) {
    const time = parseFloat(event.target.value);
    if (this.coverVideoPlayer?.nativeElement) {
      this.coverVideoPlayer.nativeElement.currentTime = time;
      this.currentVideoTime = time;
    }
  }

  formatTime(seconds: number): string {
    if (!seconds || isNaN(seconds)) return "0:00";
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  }

  captureFrameFromVideo() {
    if (!this.coverVideoPlayer?.nativeElement) {
      return;
    }

    const video = this.coverVideoPlayer.nativeElement;

    if (!video.crossOrigin) {
      video.crossOrigin = "anonymous";
      const currentSrc = video.src;
      video.src = "";
      video.src = currentSrc;
      video.addEventListener(
        "loadedmetadata",
        () => {
          this.performFrameCapture(video);
        },
        { once: true }
      );
      return;
    }

    this.performFrameCapture(video);
  }

  private performFrameCapture(video: HTMLVideoElement) {
    try {
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");

      if (ctx) {
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        canvas.toBlob((blob) => {
          if (blob) {
            const file = new File([blob], "thumbnail.png", {
              type: "image/png",
            });
            this.customCoverThumbnailFile = file;
            const reader = new FileReader();
            reader.onload = (e: any) => {
              this.customCoverThumbnailUrl = e.target.result;
              this.thumbnailSelectionMode = "upload";
              this.uploadCustomCoverThumbnail();
            };
            reader.readAsDataURL(file);
          }
        }, "image/png");
      }
    } catch (error) {
      console.error("Error capturing frame:", error);
      this.toastr.error(
        "Unable to capture frame. The video may not support cross-origin access."
      );
    }
  }

  selectAutoThumbnail(thumbnailUrl: string) {
    this.coverPosterPageURI = thumbnailUrl;
    this.selectedAutoThumbnailUrl = thumbnailUrl;
    this.thumbnailSelectionMode = "auto";

    this.convertDataUrlToFile(thumbnailUrl).then((file) => {
      this.selectedAutoThumbnailFile = file;
    });

    this.toastr.success("Thumbnail selected. Click 'Upload' to save it.");
  }

  uploadSelectedAutoThumbnail() {
    if (!this.selectedAutoThumbnailFile) {
      this.toastr.warning("Please select a thumbnail first");
      return;
    }

    this.customCoverThumbnailFile = this.selectedAutoThumbnailFile;
    this.uploadCustomCoverThumbnail();
  }

  extractFirstThreeFrames() {
    if (!this.coverVideoPlayer?.nativeElement || !this.bundleData?.url) {
      return;
    }

    const video = this.coverVideoPlayer.nativeElement;

    if (!video.crossOrigin) {
      video.crossOrigin = "anonymous";
      const currentSrc = video.src;
      video.src = "";
      video.src = currentSrc;
      video.addEventListener(
        "loadedmetadata",
        () => {
          this.performFrameExtraction(video);
        },
        { once: true }
      );
      return;
    }

    this.performFrameExtraction(video);
  }

  private performFrameExtraction(video: HTMLVideoElement) {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    if (!ctx) {
      return;
    }

    this.isCoverThumbnailLoading = true;
    this.coverThumbnails = [];

    const extractFrames = () => {
      if (
        video.readyState >= 2 &&
        video.videoWidth > 0 &&
        video.videoHeight > 0
      ) {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const duration = video.duration || 0;
        if (duration === 0 || isNaN(duration)) {
          this.isCoverThumbnailLoading = false;
          this.coverThumbnailError = "Unable to read video duration";
          return;
        }

        const frameTimes = [
          duration * 0.1,
          duration * 0.5,
          duration * 0.9,
        ].filter((t) => t >= 0 && t <= duration);

        let framesExtracted = 0;
        const totalFrames = frameTimes.length;

        frameTimes.forEach((time, index) => {
          video.currentTime = time;
          video.addEventListener(
            "seeked",
            () => {
              try {
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                canvas.toBlob((blob) => {
                  if (blob) {
                    const reader = new FileReader();
                    reader.onload = (e: any) => {
                      this.coverThumbnails.push(e.target.result);
                      framesExtracted++;
                      if (framesExtracted === totalFrames) {
                        this.isCoverThumbnailLoading = false;
                        if (
                          this.coverThumbnails.length > 0 &&
                          !this.coverPosterPageURI
                        ) {
                          this.coverPosterPageURI = this.coverThumbnails[0];
                        }
                      }
                    };
                    reader.readAsDataURL(blob);
                  }
                }, "image/png");
              } catch (error) {
                console.error("Error extracting frame:", error);
                framesExtracted++;
                if (framesExtracted === totalFrames) {
                  this.isCoverThumbnailLoading = false;
                  if (this.coverThumbnails.length === 0) {
                    this.coverThumbnailError =
                      "Unable to extract frames. Please upload a thumbnail manually.";
                  }
                }
              }
            },
            { once: true }
          );
        });
      } else {
        setTimeout(extractFrames, 100);
      }
    };

    extractFrames();
  }

  private async convertDataUrlToFile(dataUrl: string): Promise<File> {
    const response = await fetch(dataUrl);
    const blob = await response.blob();
    return new File([blob], "thumbnail.png", { type: "image/png" });
  }

  private fetchVideoThumbnails(fileName: string) {
    if (!fileName) {
      return;
    }

    const url = environment.apiBaseUrl + environment.generateThumbnailsUrl;
    const payload = {
      fileName: fileName,
      count: 3,
    };

    this.isCoverThumbnailLoading = true;
    this.coverThumbnailError = "";
    this.coverThumbnails = [];
    this.openLoadingModal("Generating thumbnails...", false);

    this.http.post(url, payload).subscribe({
      next: (response: any) => {
        const thumbnails = this.normalizeThumbnailResponse(response);
        this.coverThumbnails = thumbnails;
        this.isCoverThumbnailLoading = false;
        this.closeLoadingModal();
        if (thumbnails.length && !this.coverPosterPageURI) {
          this.coverPosterPageURI = thumbnails[0];
        }
        if (!thumbnails.length) {
          this.coverThumbnailError =
            "We couldn't auto-generate thumbnails. Upload one manually.";
        }
      },
      error: (error) => {
        this.isCoverThumbnailLoading = false;
        this.closeLoadingModal();
        this.coverThumbnailError =
          "Unable to generate thumbnails. Please upload one manually.";
        this.toastr.error("Failed to generate thumbnails. Please try again.");
        console.error("Error generating thumbnails:", error);
      },
    });
  }

  private normalizeThumbnailResponse(response: any): string[] {
    if (!response) return [];
    if (Array.isArray(response)) return response;
    if (response.thumbnails && Array.isArray(response.thumbnails)) {
      return response.thumbnails.map((t: any) =>
        typeof t === "string"
          ? t
          : environment.imageStorageBaseUrl + (t.fileName || t.url)
      );
    }
    if (response.thumbnailUrls && Array.isArray(response.thumbnailUrls)) {
      return response.thumbnailUrls;
    }
    return [];
  }
}
